import React from 'react';
import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { appTheme } from './designSystem';
import '../styles/designSystem.css';

// Static Modal/message calls also use the same theme as context-based components.
ConfigProvider.config({ holderRender: children => (
  <ConfigProvider theme={appTheme} locale={viVN}>{children}</ConfigProvider>
) });

export default function AppDesignProvider({ children }) {
  return <ConfigProvider theme={appTheme} locale={viVN}>{children}</ConfigProvider>;
}
